/** When a run or a turn happened, in the one format the run surfaces share.
 *
 * Shared because the two run-detail pages render the same header over the same
 * data: a third copy of the expression drifted immediately (a bare
 * `toLocaleString` beside this one shows "17/08/2026, 21:25:13" against
 * "17 Aug, 21:25"), which reads as two different kinds of timestamp rather than
 * the same one.
 *
 * No year, deliberately: these surfaces show recent activity, and the year is
 * noise on every row. Anything that spans years - the prompt revision history -
 * needs its own format and should not reach for this.
 */
export const formatWhen = (iso: string): string =>
  new Date(iso).toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
